/**
 * Copyright IBM Corp. 2022, 2026
 */

import classNames from 'classnames'
import { Skeleton } from '..'
import style from './skeleton-form.module.css'

export interface SkeletonFormProps {
	showHeading?: boolean
}

export const SkeletonForm = ({ showHeading }: SkeletonFormProps) => {
	return (
		<Skeleton className={style['skeleton-form']} animate={false} color="faint">
			{showHeading ? (
				<div className={style['span-all']}>
					<Skeleton className={classNames(style.item, style['max-width'])} />
				</div>
			) : null}
			<Skeleton className={classNames(style.item, style['span-all'])} />
			<Skeleton className={style.item} />
			<Skeleton className={style.item} />
			<Skeleton className={classNames(style.item, style['span-all'])} />
			<Skeleton className={classNames(style.item, style['span-all'])} />
			<Skeleton className={classNames(style.item, style['span-all'])} />
			<div className={style['span-all']}>
				<Skeleton className={classNames(style.item, style['max-width'])} />
			</div>
		</Skeleton>
	)
}

SkeletonForm.displayName = 'Skeleton'
